import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomMixerToRotateEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomMixerToRotateEventDTO.validationSchema()
  );

  readonly data: RoomMixerToRotateEvent;

  constructor(data: RoomMixerToRotateEvent) {
    this.data = JsonSchemaValidator.assert(
      RoomMixerToRotateEventDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      },
      additionalProperties: false
    };
  }
}

export interface RoomMixerToRotateEventJson extends RoomMixerToRotateEvent {}

interface RoomMixerToRotateEvent {
  roomId: RoomId;
}
